/** Dashboard / espace principal selon le rôle. */
export function getRoleHomePath(role) {
  switch (role) {
    case "admin":
      return "/admin";
    case "pharmacy":
      return "/dashboard";
    case "seller":
      return "/seller";
    case "doctor":
      return "/doctor/prescriptions";
    case "delivery":
      return "/delivery";
    case "kam":
      return "/kam";
    default:
      return "/";
  }
}

/** Page profil / compte selon le rôle (null = pas de lien profil dédié). */
export function getRoleProfilePath(role) {
  switch (role) {
    case "client":
      return "/profile";
    case "pharmacy":
      return "/dashboard/profile";
    case "admin":
      return "/admin/change-password";
    default:
      return null;
  }
}
